import { useCallback } from 'react'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'

import { SHIPMENT_STAGES } from '#/entities/shipment'
import { ShipmentDetailsPage } from '#/pages/shipment'
import { useShipmentSidebar } from '#/widgets/shipment-sidebar'

export const Route = createFileRoute('/_shell/leads/$leadId/')({
  component: DetailsRoute,
})

function DetailsRoute() {
  const { leadId } = Route.useParams()
  const navigate = useNavigate()
  const listSearch = useSearch({ strict: false })
  const handleClose = useCallback(() => {
    void navigate({ to: '/leads', search: listSearch as never })
  }, [navigate, listSearch])
  const openShipmentSidebar = useShipmentSidebar(SHIPMENT_STAGES.LEAD)
  const handleMinimize = useCallback(async () => {
    await navigate({ to: '/leads', search: listSearch as never })
    openShipmentSidebar(leadId)
  }, [navigate, listSearch, openShipmentSidebar, leadId])
  return (
    <ShipmentDetailsPage
      stage={SHIPMENT_STAGES.LEAD}
      shipmentId={leadId}
      onClose={handleClose}
      onMinimize={() => void handleMinimize()}
    />
  )
}
